export default __webpack_public_path__ + "images/online-payment/comgate.png?04a130d132c52706855f42ca31ad0bd1ff5bf9f3074d892a9d9a7621b716ed8d";